const Button = ({children, onClick, className, disabled = false}) => {
  let touchHandled = false;

  const handleClick = (event) => {
    if (disabled) return;
    // Si ya se manejó un evento touch, ignorar el click
    if (touchHandled) {
      touchHandled = false;
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    if (onClick) onClick(event);
  };

  const handleTouchStart = (event) => {
    if (disabled) return;
    event.stopPropagation();
  };

  const handleTouchEnd = (event) => {
    if (disabled) return;
    event.preventDefault();
    event.stopPropagation();
    touchHandled = true;
    if (onClick) onClick(event);
  };

  const handleMouseDown = (event) => {
    if (disabled) return;
    event.stopPropagation();
  };

  return (
    <button
      onClick={handleClick}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onMouseDown={handleMouseDown}
      className={`
        rounded-full focus:outline-none   
        text-white font-light leading-none 
        flex items-center
        overflow-hidden
        border-2u border-[#A9AAB5]
        ${disabled ? 'pointer-events-none opacity-50' : 'pointer-events-auto'}
        ${className}`}
      style={{
        touchAction: 'manipulation',
        WebkitTapHighlightColor: 'transparent',
        userSelect: 'none',
      }}
      disabled={disabled}
    >
      {children}
    </button>
);
};

export default Button;